import React, { Component } from 'react'
import '../style/ExploreFilter.css';
import ExploreFilterCheckbox from '../components/ExploreFilterCheckbox';

const gadgetsItems1 = ["Crown",
    "Cowboy Hat",
    "Baseball Cap",
    "Aureole",
    "Devil Horns"]
const gadgetsItems2 = [
    "Mustache",
    "Thug Life Glasses",
    "Covid Mask",
    "Monocle"
]

const gadgetsItems3 = [
    "Joint",
    "Tennis Racket",
    "Brush And Easel",
    "Light Saber",
    "Boxing Gloves",
    "Smartphone",
    "Baseball Bat",
    "Grail",
    "Katana",
    "Shuriken",
    "Trident"
]
const gadgetsItems4 = [
    "Tie",
    "Chain $",
    "T-shirt"
]
const gadgetsItems5 = [
    "Belt",
    "Hawaii Skirt",
    "Pants"
]
const gadgetsItems6 = [
    "Fly",
    "Bubbles"
]

const gadgets = {
    gadgets1: ["Crown",
        "Cowboy Hat",
        "Baseball Cap",
        "Aureole",
        "Devil Horns", "Mustache",
        "Thug Life Glasses",],
    gadgets2: ["Covid Mask",
        "Monocle", "Joint",
        "Tennis Racket",
        "Brush And Easel",
        "Light Saber",
        "Boxing Gloves",],
    gadgets3: ["Smartphone",
        "Baseball Bat",
        "Grail",
        "Katana",
        "Shuriken",
        "Trident", "Tie",],
    gadgets4: [
        "Chain $",
        "T-shirt", "Belt",
        "Hawaii Skirt",
        "Pants", "Fly",
        "Bubbles"
    ]
}

const bodies = {
    bodies1: ["Green", "Orange",],
    bodies2: ["Pink",
        "Blue",],
    bodies3: ["Purple",
        "Cyan",],
    bodies4: ["Red",
        "Gold",],
    bodies5: ["Black",
        "White"],
}
export class ExploreFilter extends Component {

    constructor(props) {
        super();
        this.state = {
            //filters: [],
            body: "",
            gadgets: []
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    handleFilterChange(type, filterName, checked) {
        console.log(type, filterName, checked)
        if (checked) {

            if (type == "gadget") {
                this.setState(previousState => ({
                    gadgets: [...previousState.gadgets, filterName]
                }), () => {
                    console.log(this.state.gadgets)
                })
            }
            else if (type == "body") {
                this.setState(previousState => ({
                    body: filterName
                }), () => {
                    console.log(this.state.body)
                })
            }
            // this.setState(previousState => ({
            //     filters: [...previousState.filters, {
            //         name: filterName,
            //         type: type
            //     }]
            // }), () => {
            //     console.log(this.state.filters)
            // })

        }
        else {
            if (type == "gadget") {
                let previousGadgets = [...this.state.gadgets];
                let index = previousGadgets.findIndex(e => e.name === filterName)[0];
                if (index !== -1) {
                    previousGadgets.splice(index, 1);
                    this.setState({
                        gadgets: previousGadgets
                    }, () => {
                        console.log(this.state.gadgets)
                    })
                }
            }
            else if (type == "body") {
                this.setState({
                    body: ""
                }, () => {
                    console.log(this.state.gadgets)
                })
            }
            // let previousFilters = [...this.state.filters];
            // let index = previousFilters.findIndex(e => e.name === filterName)[0];
            // if (index !== -1) {
            //     previousFilters.splice(index, 1);
            //     this.setState({
            //         filters: previousFilters
            //     }, () => {
            //         console.log(this.state.filters)
            //     })
            // }
            let previousGadgets = [...this.state.gadgets];
            let index = previousGadgets.findIndex(e => e.name === filterName)[0];
            if (index !== -1) {
                previousGadgets.splice(index, 1);
                this.setState({
                    gadgets: previousGadgets
                }, () => {
                    console.log(this.state.gadgets)
                })
            }
        }
    }

    applyFilter() {
        this.props.toggleFilterPopup();
    }

    render() {
        return (
            <div onClick={(e) => {
                if (e.target.id == "exploreFilter") {
                    this.props.toggleFilterPopup();
                }
            }} id="exploreFilter">
                <div id="exploreFilterBox">
                    <h1>Filter</h1>
                    <h2>Bodies</h2>
                    <div className="explore-filters">
                        {
                            Object.keys(bodies).map(key => (
                                <div className="explore-filter-column">
                                    {bodies[key].map(filter => (<ExploreFilterCheckbox handleFilterChange={this.handleFilterChange} filterName={filter} type={"body"} />))}
                                </div>
                            ))
                        }
                    </div>
                    <h2>Gadgets</h2>
                    <div className="explore-filters">
                        <div className="explore-filter-column">
                            {gadgets.gadgets1.map(filter => (<ExploreFilterCheckbox handleFilterChange={this.handleFilterChange} filterName={filter} type={"gadget"} />))}
                        </div>
                        <div className="explore-filter-column">
                            {gadgets.gadgets2.map(filter => (<ExploreFilterCheckbox handleFilterChange={this.handleFilterChange} filterName={filter} type={"gadget"} />))}
                        </div>
                        <div className="explore-filter-column">
                            {gadgets.gadgets3.map(filter => (<ExploreFilterCheckbox handleFilterChange={this.handleFilterChange} filterName={filter} type={"gadget"} />))}
                        </div>
                        <div className="explore-filter-column">
                            {gadgets.gadgets4.map(filter => (<ExploreFilterCheckbox handleFilterChange={this.handleFilterChange} filterName={filter} type={"gadget"} />))}
                        </div>

                    </div>
                    <button onClick={(e) => {
                        this.props.toggleFilterPopup();
                        //this.props.filterMetadataByTrait(this.state.filters);
                        this.props.filterMetadataByTrait(this.state.gadgets,this.state.body);
                    }} id="applyFilterBtn">APPLY</button>
                </div>
            </div>
        )
    }
}

export default ExploreFilter
